import { Grid } from '@mui/material';
import { FocalPointImage } from '@/types/generated';
import { getBannerImageUrl } from './ODPHero.helpers';
import { mobileBrandBannerStyles } from './ODPHero.styles';
import ImageWrapper from '@shared-components/components/ImageWrapper';
interface BannerProps {
  bannerImages: FocalPointImage[];
  originalBrand: string;
}
export default function Banner({
  bannerImages,
  originalBrand
}: Readonly<BannerProps>) {
  const bannerImageUrl = getBannerImageUrl(bannerImages, originalBrand);
  if (!bannerImageUrl) {
    return null;
  }
  return <Grid data-testid="section-odp-hero-banner" container sx={mobileBrandBannerStyles.containerStyles} data-sentry-element="Grid" data-sentry-component="Banner" data-sentry-source-file="Banner.tsx">
			<ImageWrapper src={bannerImageUrl} alt="" style={mobileBrandBannerStyles.imageStyles} data-sentry-element="ImageWrapper" data-sentry-source-file="Banner.tsx" />
		</Grid>;
}